import type { BlissBasicPublicCatalog } from '../config/blissBasicCatalog'
import { BLISS_BASIC_CATALOG_API } from '../config/blissBasicCatalog'
import { mergeConfiguratorSteps } from '../utils/blissBasicConfiguratorDefaults'
import { buildBlissBasicWizardSteps } from '../utils/blissBasicOptionWizard'

type CatalogApiPayload = Omit<BlissBasicPublicCatalog, 'optionWizardSteps'> & {
  optionWizardSteps?: BlissBasicPublicCatalog['optionWizardSteps']
}

export async function fetchBlissBasicPublicCatalog(
  slug?: string,
): Promise<BlissBasicPublicCatalog | null> {
  try {
    const q = slug ? `?slug=${encodeURIComponent(slug)}` : ''
    const res = await fetch(`${BLISS_BASIC_CATALOG_API}${q}`)
    if (!res.ok) return null
    const raw = (await res.json()) as CatalogApiPayload
    const photos = (raw.photos ?? []).map((p) => ({
      ...p,
      optionCategory: p.optionCategory ?? null,
      inStock: p.inStock !== false,
      active: p.active !== false,
    }))
    const configuratorSteps = mergeConfiguratorSteps(
      raw.configuratorSteps,
      raw.configuratorStepCopy ?? {},
    )
    return {
      ...raw,
      photos,
      optionWizardSteps: raw.optionWizardSteps ?? buildBlissBasicWizardSteps(photos),
      configuratorSteps,
      configuratorStepCopy: raw.configuratorStepCopy ?? {},
    }
  } catch {
    return null
  }
}
